import React from "react";
import MainLayouts from "layouts/MainLayouts";
import EmailSuiteOrder from "./EmailSuiteOrder";

const EmailSuite = () => {
  return (
    <MainLayouts summary={false}>
      <EmailSuiteOrder />
    </MainLayouts>
  );
};

export default EmailSuite;
